export default "__VITE_ASSET__D0J_m3iQ__"